import "./bootstrap";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import { isLoggedIn, validateSession } from "./utils/auth";

Vue.use(Vuetify);

Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  if (!to.matched.some((record) => record.meta.isPublic) && !isLoggedIn()) {
    next({
      path: "/login",
    });
  } else {
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find((record) => record.meta && record.meta.title);

    await validateSession(to, from, next);

    if (nearestWithTitle) {
      document.title = to.meta.title;
    }
    if (
      to.meta.role != store.getters.getInfoUser &&
      !to.name == "login"
    ) {
      next({
        path: "/login",
      });
    }
    next();
  }
});

import es from "vuetify/es5/locale/es";


new Vue({
  router,
  store,
  vuetify: new Vuetify({
    icons: {
      iconfont: "mdi",
    },
    lang: {
      locales: { es },
      current: "es",
    },
  }),
  render: (h) => h(App),
}).$mount("#app");
